module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag23_1104AT.b05f4b91.jpg";